import apiClient from './axiosConfig'; // Import apiClient
import { API_ENDPOINTS } from '../constants';

const fetchServices = async (params = {}) => {
  const query = new URLSearchParams();
  if (params.paginate) query.append('paginate', params.paginate);
  if (params.limit) query.append('limit', params.limit);
  if (params.per_page) query.append('per_page', params.per_page);
  if (params.page) query.append('page', params.page);

  try {
    const response = await apiClient.get(`${API_ENDPOINTS.SERVICES}?${query.toString()}`); // Use apiClient.get
    return response.data; // Axios wraps response in .data
  } catch (error) {
    console.error('Error fetching services:', error);
    throw error;
  }
};

const fetchServiceDetail = async (slug) => {
  try {
    const response = await apiClient.get(API_ENDPOINTS.SERVICE_DETAIL(slug)); // Use apiClient.get
    return response.data; // Axios wraps response in .data
  } catch (error) {
    console.error('Error fetching service detail:', error);
    throw error;
  }
};

export { fetchServices, fetchServiceDetail };